"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCustomMenu = void 0;

var _reactQuery = require("react-query");

var _api = require("../api");

var _types = require("../../store/types");

var useCustomMenu = function useCustomMenu(_a) {
  var locationNumber = _a.locationNumber,
      _b = _a.menuItemCode,
      menuItemCode = _b === void 0 ? '' : _b,
      serviceMethod = _a.serviceMethod;

  var _c;

  var queryClient = (0, _reactQuery.useQueryClient)();
  var store = queryClient.getQueryData([_types.QueryKeys.Store, locationNumber]);
  var storeId = (_c = store === null || store === void 0 ? void 0 : store.store) === null || _c === void 0 ? void 0 : _c.storeId;
  var request = {
    customBannerCode: menuItemCode,
    locationNumber: locationNumber,
    serviceMethod: serviceMethod,
    storeId: storeId
  };
  return (0, _reactQuery.useQuery)(["CustomMenu"
  /* CustomMenu */
  , locationNumber], function () {
    return (0, _api.fetchCustomMenu)(request);
  }, {
    enabled: !!(locationNumber && storeId && menuItemCode),
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false
  });
};

exports.useCustomMenu = useCustomMenu;